import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import ResponsiveFrame from '../../ResponsiveFrame';
class SidebarBlog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tabcloud: [
                {
                    id: '1',
                    tablink: 'M&E'
                },
                {
                    id: '2',
                    tablink: 'Statistics'
                },
                {
                    id: '3',
                    tablink: 'Research'
                },
                {
                    id: '4',
                    tablink: 'Evaluation'
                },
                {
                    id: '5',
                    tablink: 'Data'
                },
                {
                    id: '6',
                    tablink: 'Training'
                },
                {
                    id: '7',
                    tablink: 'Consulting'
                },
                {
                    id: '8',
                    tablink: 'Analysis'
                },
                {
                    id: '9',
                    tablink: 'Impact'
                }
            ]
        }
    }
    render() {
        return (
                <div className="col-md-4">
                    <div className="sidebar right">
                        <ResponsiveFrame
                            className="small"
                            padding="26px"
                            margin="0 0 24px 0"
                            borderRadius="0"
                            backgroundColor="#ffffff"
                            border="1px solid #e0e0e0"
                            boxShadow="none"
                            style={{ width: '100%', minHeight: '230px' }}>
                            <aside className="widget widget-brochure">
                                <div className="brochure-box-title" style={{textAlign: 'center', marginBottom: '20px'}}>
                                    <h5 className="brochure-title" style={{
                                        fontSize: '20px',
                                        fontWeight: '600',
                                        color: '#333',
                                        marginBottom: '10px'
                                    }}>Our Brochure</h5>
                                    <p style={{
                                        color: '#666',
                                        fontSize: '15px',
                                        lineHeight: '1.5',
                                        marginBottom: '25px'
                                    }}>View our MERL and Statistics services overview
                                        for an easy to read guide on all of the services offered.</p>
                                </div>
                                <div style={{ textAlign: 'center', marginTop: '10px' }}>
                                    <a
                                        href="/brochures/stateelite-services.pdf"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        download
                                        style={{
                                            display: 'inline-block',
                                            padding: '12px 28px',
                                            backgroundColor: '#62B6E8',
                                            color: '#fff',
                                            textDecoration: 'none',
                                            borderRadius: '0',
                                            fontSize: '15px',
                                            fontWeight: '500',
                                            transition: 'all 0.3s ease'
                                        }}
                                        onMouseOver={(e) => {
                                            e.target.style.backgroundColor = '#2F7FAE';
                                            e.target.style.transform = 'translateY(-2px)';
                                        }}
                                        onMouseOut={(e) => {
                                            e.target.style.backgroundColor = '#62B6E8';
                                            e.target.style.transform = 'translateY(0)';
                                        }}
                                    >
                                        <i className="fa fa-file-pdf-o" style={{marginRight: '8px'}}></i>
                                        Download PDF
                                    </a>
                                    <a
                                        href="/brochures/stateelite-services.doc"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        download
                                        style={{
                                            display: 'inline-block',
                                            padding: '10px 25px',
                                            backgroundColor: 'transparent',
                                            color: '#62B6E8',
                                            textDecoration: 'none',
                                            borderRadius: '0',
                                            fontSize: '14px',
                                            fontWeight: '500',
                                            transition: 'all 0.3s ease',
                                            border: '1px solid #62B6E8',
                                            margin: '5px'
                                        }}
                                        onMouseOver={(e) => {
                                            e.target.style.backgroundColor = '#62B6E8';
                                            e.target.style.color = '#ffffff';
                                        }}
                                        onMouseOut={(e) => {
                                            e.target.style.backgroundColor = 'transparent';
                                            e.target.style.color = '#62B6E8';
                                        }}
                                    >
                                        <i className="fa fa-file-word-o" style={{marginRight: '8px'}}></i>
                                        Download DOC
                                    </a>
                                </div>
                            </aside>
                        </ResponsiveFrame>
                        <ResponsiveFrame
                            className="small"
                            padding="20px"
                            margin="0 0 20px 0"
                            borderRadius="0"
                            backgroundColor="#ffffff"
                            border="1px solid #e0e0e0"
                            boxShadow="none"
                            style={{ width: '100%', minHeight: '200px' }}>
                            <aside className="widget widget-tags">
                                <h3 className="widget-title" style={{
                                    fontSize: '18px',
                                    fontWeight: '600',
                                    marginBottom: '20px',
                                    color: '#333',
                                    paddingBottom: '10px',
                                    borderBottom: '1px solid #e0e0e0'
                                }}>TAGS</h3>
                                <div className="tag-cloud" style={{ display: 'flex', flexWrap: 'wrap' }}>
                                    {
                                        this.state.tabcloud.map(data =>(
                                            <Link key={data.id}
                                                   to="/blog"
                                                   title=""
                                                   className="tag-link"
                                                   style={{
                                                       display: 'inline-block',
                                                       padding: '6px 14px',
                                                       backgroundColor: '#f5f5f5',
                                                       color: '#333',
                                                       textDecoration: 'none',
                                                       borderRadius: '0',
                                                       fontSize: '14px',
                                                       margin: '0 8px 8px 0',
                                                       transition: 'all 0.3s ease',
                                                       border: '1px solid #e0e0e0'
                                                   }}
                                                   onMouseOver={(e) => {
                                                       e.target.style.backgroundColor = '#62B6E8';
                                                       e.target.style.color = '#ffffff';
                                                       e.target.style.borderColor = '#62B6E8';
                                                   }}
                                                   onMouseOut={(e) => {
                                                       e.target.style.backgroundColor = '#f5f5f5';
                                                       e.target.style.color = '#333';
                                                       e.target.style.borderColor = '#e0e0e0';
                                                   }}
                                            >
                                                {data.tablink}
                                            </Link>
                                        ))
                                    }
                                </div>
                            </aside>
                        </ResponsiveFrame>
                    </div>
                </div>
        );
    }
}

export default SidebarBlog;
